const translationsSk = {
    "FOOTER_RIGHT_TEXT"                 : "Táto stránka používa cookies",
};

export default translationsSk;
